var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManageEntity = function SvgManageEntity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 144,
    fill: "none",
    viewBox: "0 0 168 144"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 132,
    height: 102,
    x: 18,
    y: 21,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.506 21.177H18.494v101.647h131.012z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00D041",
    d: "M59.37 91.796a3.86 3.86 0 0 1-2.928-1.343L45.759 78.031a3.845 3.845 0 0 1 .414-5.43 3.86 3.86 0 0 1 5.438.413l8.268 9.616 43.514-34.413a3.86 3.86 0 0 1 5.418.628 3.845 3.845 0 0 1-.629 5.409L61.764 90.963a3.85 3.85 0 0 1-2.393.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M125.67 52.758a4.29 4.29 0 0 1-4.291-4.169 4.29 4.29 0 0 1 4.174-4.404l1.697-.046 1.929-8.674c1.012-4.55 4.978-7.726 9.646-7.726a4.29 4.29 0 0 1 4.294 4.287 4.29 4.29 0 0 1-4.294 4.288c-.61 0-1.129.415-1.261 1.01l-2.654 11.939a4.29 4.29 0 0 1-4.073 3.356l-5.045.14h-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M33.006 89.493h53.518a5.45 5.45 0 0 1 5.451 5.441v3.108h-64.42v-3.108a5.45 5.45 0 0 1 5.451-5.441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M97.979 94.99H21.552a3.055 3.055 0 0 0-3.058 3.05 3.055 3.055 0 0 0 3.058 3.053h76.427a3.055 3.055 0 0 0 3.057-3.052 3.054 3.054 0 0 0-3.057-3.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5E5E",
    d: "M143.835 120.707a5.664 5.664 0 0 1-5.665-5.53l-1.209-53.154-13.511 52.337a5.67 5.67 0 0 1-6.904 4.068 5.657 5.657 0 0 1-4.074-6.892l14.417-55.847.019-.067a10.88 10.88 0 0 1 4.168-5.886 10.9 10.9 0 0 1 6.941-1.977 10.84 10.84 0 0 1 7.158 3.294 10.8 10.8 0 0 1 3.042 7.26l1.289 56.606a5.664 5.664 0 0 1-5.538 5.787h-.131z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5E5E",
    d: "M137.516 122.824a1.076 1.076 0 0 1-.311-2.103l7.787-2.353a1.075 1.075 0 0 1 .621 2.056l-7.786 2.353a1 1 0 0 1-.313.047zM117.376 118.542h-7.507a1.074 1.074 0 1 1 0-2.148h7.507a1.075 1.075 0 1 1 0 2.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84D4F",
    d: "M127.27 70.908a2.143 2.143 0 0 1-1.605-3.567l10.726-12.065a2.15 2.15 0 0 1 3.032-.18c.886.785.967 2.14.18 3.026l-10.725 12.066a2.15 2.15 0 0 1-1.607.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M144.424 50.604s-6.832 2.859-13.525-1.356l5.295-4.04 8.051 4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M137.994 60.986a4.3 4.3 0 0 1-1.971-.48 4.285 4.285 0 0 1-1.841-5.778c2.243-4.33 4.817-9.879 5.105-11.31l.56-4.173c.217-1.609-.148-2.514-.371-2.768-.036-.041-.144-.165-.653-.165a4.29 4.29 0 0 1-4.294-4.287 4.29 4.29 0 0 1 4.294-4.287c2.842 0 5.37 1.099 7.119 3.093 2.07 2.362 2.929 5.756 2.419 9.552l-.572 4.264-.016.11c-.507 3.153-4.337 10.779-5.961 13.912a4.29 4.29 0 0 1-3.817 2.319z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M143.837 35.09h-9.999v12.067h9.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84D4F",
    d: "M140.505 22.614a2.15 2.15 0 0 1-1.319 2.738 2.153 2.153 0 0 1-2.742-1.319 2.14 2.14 0 0 1 .25-1.912c.249-.37.616-.665 1.07-.823a2.16 2.16 0 0 1 2.276.55c.203.213.362.47.467.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M138.309 21.742a4.7 4.7 0 0 0 .907-.432 2.14 2.14 0 0 0-2.436.693c.507 0 1.024-.082 1.529-.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84D4F",
    d: "M107.757 51.45a2.146 2.146 0 0 1-2.143-2.03 2.146 2.146 0 0 1 2.029-2.254l15.395-.825a2.15 2.15 0 0 1 2.259 2.025 2.145 2.145 0 0 1-2.029 2.255l-15.395.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84D4F",
    d: "M109.934 49.409h-2.482a1.03 1.03 0 0 1-1.031-1.03 1.03 1.03 0 0 1 1.031-1.028h2.482a1.03 1.03 0 0 1 1.031 1.029 1.03 1.03 0 0 1-1.031 1.029"
  }))));
};
export default SvgManageEntity;